import styles from "./Prompts.module.css";
import Button from "../buttons/Button";
import { useContext } from "react";
import AuthContext from "../../context/AuthContext";
import FullscreenCard from "../containers/FullscreenCard";

const ImagePreviewPrompt = ({
  preview,
  promptText,
  confirmHandler,
  setConfirmDeletePrompt,
  deleteable = true,
}) => {
  const authCtx = useContext(AuthContext);

  return (
    <>
      {preview && (
        <FullscreenCard>
          <p className={styles.confirmPromptText}>{promptText}</p>
          <img
            className={styles.previewPhoto}
            src={preview.base64Src ? preview.base64Src : preview.url}
            alt={preview.base64Key ? preview.base64Key : preview.name}
            key={preview.base64Key ? preview.base64Key : preview.url}
          ></img>
          <div className={styles.confirmButtonDiv}>
            <Button text={"OK"} disabled={false} onClick={confirmHandler} />
            {!authCtx.isReadOnly && deleteable && (
              <Button
                text={"Delete"}
                disabled={false}
                onClick={setConfirmDeletePrompt}
              />
            )}
          </div>
        </FullscreenCard>
      )}
    </>
  );
};

export default ImagePreviewPrompt;
